var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.5V27.75C28 28.9219 27.103 29.875 26 29.875H2C0.897 29.875 0 28.9219 0 27.75V23.5C0 22.9135 0.448 22.4375 1 22.4375C1.552 22.4375 2 22.9135 2 23.5V27.75H26V23.5C26 22.9135 26.448 22.4375 27 22.4375C27.552 22.4375 28 22.9135 28 23.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29325 15.7512C5.90225 15.3358 5.90225 14.6642 6.29325 14.2488C6.68425 13.8334 7.31625 13.8334 7.70725 14.2488L13.0003 19.8726V1.1875C13.0003 0.601 13.4483 0.125 14.0003 0.125C14.5523 0.125 15.0003 0.601 15.0003 1.1875V19.8726L20.2933 14.2488C20.6843 13.8334 21.3163 13.8334 21.7073 14.2488C22.0983 14.6642 22.0983 15.3358 21.7073 15.7512L14.7073 23.1887C14.3113 23.6105 13.6763 23.5967 13.2923 23.1887L6.29325 15.7512Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/downloadBlack.127c062f4e5cbc087b76267fa3d6f3d0.svg";
export { ForwardRef as ReactComponent };